import { defineComponent as _defineComponent } from 'vue'
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { randomId } from '~/helpers/randomId';
import AzInput from '~/components/_next/atoms/AzInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantitySelector',
  props: {
  qty: {
    type: [Number, String],
    default: 1,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 500,
  },
  isSticky: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
},
  setup(__props) {



function handleInput(qty, listeners, min, max) {
  // adjust qty per min/max if needed
  const minimumForInput = 1;
  const minimum = min ?? 1;
  if (qty === '0') {
    qty = minimumForInput;
  } else if (qty === 0) {
    listeners.removeProduct && listeners.removeProduct();
  } else if (qty < minimum || isNaN(qty)) {
    qty = minimum;
  } else if (max !== null && qty > max) {
    qty = max;
  }
  return listeners.input && listeners.input(qty);
}

function handleBlur(listeners, qty) {
  return listeners.input && listeners.input(qty);
}

function uniqueKey() {
  return 'quantitySelector' + randomId();
}
function restrictChars(event) {
  // Prevent 'e', '+' and '-' from being typed
  if (event.charCode === 101 || event.charCode === 45 || event.charCode === 43) {
    event.preventDefault();
  }
}

return { __sfc: true,handleInput, handleBlur, uniqueKey, restrictChars, AzButton, AzInput }
}

})